import { jsx as _jsx } from "react/jsx-runtime";
import { trackEvent } from "@faire/web--source/common/trackEvent";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import React from "react";
var buildVisibilityEventPath = function(name) {
    return "logged-out-category-page/".concat(name, "/visible");
};
export var VisibilityTracker = function(param) {
    var name = param.name, children = param.children;
    var viewRef = useDoActionWhenVisible(function() {
        trackEvent(buildVisibilityEventPath(name));
    });
    return /*#__PURE__*/ _jsx("div", {
        ref: viewRef,
        children: children
    });
};
